import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMixB: IAbstractModule = {
  type: IModuleType.mixZ,
  name: 'Z Mix B (11-18)',
  hasScreen: false,
  columns: [
    [
      {
        name: "1",
        connector: "11",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "2",
        connector: "12",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "3",
        connector: "13",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "4",
        connector: "14",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "5",
        connector: "15",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "6",
        connector: "16",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "7",
        connector: "17",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "8",
        connector: "18",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
